<div class="notification" *ngFor="let n of notification" @notificationAnim>
    {{ n.text }}
</div>